import React, { Fragment, useState } from "react";
import { connect } from "react-redux";
import { logout } from "../redux/actions/LoggedInAction";
import UserResources from "../resources/UserResources";
import toast from 'react-hot-toast';


const mobileMenuLink = {display: 'block', padding: '12px 20px', color: '#003165', textDecoration: 'none', fontSize: '15px', fontWeight: 'bold', borderBottom: '1px solid #f0f0f0'};
const mobileMenuQuickLink = {display: 'block', padding: '11px 20px 11px 16px', color: '#003165', textDecoration: 'none', fontSize: '14px', fontWeight: 'bold', borderBottom: '1px solid #f0f0f0', borderLeft: '4px solid #ffa800', backgroundColor: '#fffbf2'};
const mobileMenuSubLink = {display: 'block', padding: '10px 20px 10px 32px', color: '#444', textDecoration: 'none', fontSize: '14px', borderBottom: '1px solid #f5f5f5', backgroundColor: '#f8f9fa'};
const mobileMenuHeading = {padding: '12px 16px', color: '#fff', fontSize: '14px', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '0.5px', backgroundColor: '#003165', borderBottom: '1px solid #00254d', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center'};

function Topbar({isLoggedIn, loggedInUser, logout}){
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [openSections, setOpenSections] = useState({});
    const userResources = new UserResources()

    const toggleSection = (section) => {
        setOpenSections(prev => ({...prev, [section]: !prev[section]}));
    };        


    const handleLogOut = () => {
        userResources.user_logout(loggedInUser).then(res => {      
            if (res.error.length > 1) {
                toast.error("Logout failed")
            } else {     
                localStorage.removeItem('access_token');
                localStorage.removeItem('refresh_token');
                localStorage.removeItem('token');
                logout()
                toast.success("Successfully logged out")
                setTimeout(() => {
                    window.location.href = window.location.origin + '/';
                  }, 200);
            }}).catch((err) => {
                toast.error("Network Error: " + err);
            });     
  
      };
    
    const handleMenuToggle = () => {
        // Implement logic to toggle mobile menu visibility
        setIsMenuOpen(!isMenuOpen); // Toggle the menu state
    };

    return(
        <Fragment>
            <style>{`
                #mobile-nav-btn {
                    float: right;
                    font-size: 24px;
                    line-height: 50px;
                    color: #fff;
                    margin-left: 40px;
                    display: none;
                    text-decoration: none;
                }
                .sticky #mobile-nav-btn { color: #333; }
                @media (max-width: 992px) {
                    #mobile-nav-btn { display: block !important; }
                    .sf-menu.dd-menu { display: none !important; }
                }
            `}</style>
            <div className="site-header-wrapper">
        {/* <!-- Site Header --> */}
        <header className="site-header">
            <div className="container" style={{backgroundColor:"#003165"}}>
                <div className="site-logo">
                    <a href="/" className="default-logo"><img src="https://ik.imagekit.io/seyi/Tlc_Media/Site_Images/UpdatedLibertyLogo.jpeg" alt="Logo" style={{maxWidth: "100%", maxHeight:"50px", height: "auto", width: "auto"}}/></a>
                    <a href="/" className="default-retina-logo"><img src="https://ik.imagekit.io/seyi/Tlc_Media/Site_Images/UpdatedLibertyLogo.jpeg" alt="Logo" style={{maxWidth: "100%", maxHeight:"50px", height: "auto", width: "auto"}}/></a>
                    <a href="/" className="sticky-logo"><img src="https://ik.imagekit.io/seyi/Tlc_Media/Site_Images/UpdatedLibertyLogo.jpeg" alt="Logo" style={{maxWidth: "100%", maxHeight:"50px", height: "auto", width: "auto"}}/></a>
                    <a href="/" className="sticky-retina-logo"><img src="https://ik.imagekit.io/seyi/Tlc_Media/Site_Images/UpdatedLibertyLogo.jpeg" alt="Logo" style={{maxWidth: "100%", maxHeight:"50px", height: "auto", width: "auto"}}/></a>
                </div>
             	<a href="#" id="mobile-nav-btn" onClick={(e) => { e.preventDefault(); handleMenuToggle(); }}><i className="fa fa-bars"></i></a>


           

                    <div style={{justifyContent:"center", alignItems:"center"}}>
                        <ul className="sf-menu dd-menu pull-right" role="menu" style={{justifyContent:"center", alignItems:"center"}}>
                            <li><a style={{color:'#FFFFFF'}} href="/"><strong>Home</strong></a></li>                            
                            <li><a style={{color:'#FFFFFF'}} href="/events"><strong>Events</strong></a>
                                <ul style={{justifyContent:"center", alignItems:"center"}}>
                                    <li><a href="/events">Upcoming Events</a></li>
                                    <li><a href="/mediabooking">Book Media Team</a></li>
                                    {isLoggedIn && loggedInUser && loggedInUser['role.name'] !== 'checklist_viewer' ? <li><a href="/mevents">Media Only Events</a></li> : <></>}
                                </ul>
                            </li>

                               {isLoggedIn && loggedInUser && loggedInUser['role.name'] === 'checklist_viewer' && (
                                        <>
                                            <li>
                                                <a style={{color:'#FFFFFF'}} href="/readinesscheck"><strong>Production Day</strong></a>
                                                <ul>
                                                    <li><a href="/readinesscheck">Production Checklist</a></li>
                                                    <li><a href="/productionroom">In Production Room</a></li>
                                                </ul>
                                            </li>
                                            <li><a style={{color:'#FFFFFF'}} href="#" onClick={handleLogOut}><strong>Logout</strong></a></li>
                                        </>
                                    )}
                                    {isLoggedIn && loggedInUser && loggedInUser['role.name'] !== 'checklist_viewer' && (
                                        <>
                                            <li>
                                            <a style={{color:'#FFFFFF'}} href="/about"><strong>The Team</strong></a>
                                            <ul>
                                                <li><a href="/about">About Us</a></li>
                                                <li><a href="/teamdistribution">Team Distribution</a></li>
                                                <li><a href="/clockin">Clock In</a></li>
                                                <li><a href="/rota">Rota</a></li>
                                                <li>
                                                    <a href="#">Absence</a>
                                                    <ul>
                                                        <li><a href="/absences">View Absences</a></li>
                                                        <li><a href="/requestabsence">Request Absence</a></li>
                                                    </ul>
                                                </li>
                                                { loggedInUser && loggedInUser['role.name'] === 'admin' ?
                                                <li><a href="https://docs.google.com/spreadsheets/d/1_25kdmgYRLzpgKmOmW5ZE34Qyuggf7sjLJqDk1pydeQ/edit?usp=sharing" target="_blank">Team Skills Matrix</a></li> :
                                                <></>
                                                }
                                                <li><a href="/birthdays">Team Birthdays</a></li>
                                                <li><a href="/improvements">Process Improvements</a></li>
                                                <li><a href="/contact">Contact us</a></li>
                                            </ul>
                                            </li>
                                            <li><a style={{color:'#FFFFFF'}} href="/onboarding"><strong>Training and Onboarding</strong></a></li>
                                            <li>
                                                <a style={{color:'#FFFFFF'}} href="/readinesscheck"><strong>Production Day</strong></a>
                                                <ul>
                                                    <li><a href="/readinesscheck">Production Checklist</a></li>
                                                    <li><a href="/productionroom">In Production Room</a></li>
                                                </ul>
                                            </li>

                                            {loggedInUser && loggedInUser['role.name'] === 'admin' && (
                                            <li>
                                                <a style={{color:'#FFFFFF'}} href="#"><strong>Admins Panel</strong></a>
                                                <ul className="dropdown">
                                                <li><a href="/manageusers">Manage Users</a></li>
                                                <li><a href="/manageevents">Manage Events</a></li>
                                                <li><a href="/managemembersclockin">Manage ClockIn</a></li>
                                                <li><a href="/manageabsences">Manage Absences</a></li>
                                                <li> 
                                                    <a href="#">Manage Rota</a>
                                                    <ul>
                                                        <li><a href="/createrota">Create Rota</a></li>
                                                        <li><a href="/managerota">Update Rota</a></li>
                                                    </ul>
                                                </li>
                                                <li> 
                                                    <a href="#">Manage Rota Config</a>
                                                    <ul>
                                                        <li><a href="/managerotaroles">Rota Roles</a></li>
                                                        <li><a href="/manageconfig">Team Config</a></li>
                                                    </ul>
                                                </li>
                                                
                                                <li><a href="/broadcastemail">Broadcast Email</a></li>
                                                <li>
                                                    <a href="#">Manage Incidents</a>
                                                    <ul>
                                                        <li><a href="/addincident">Add Incident</a></li>
                                                        <li><a href="/viewincident">View Incidents</a></li>
                                                    </ul>
                                                </li> 
                                                <li><a href="/manageprodchecklist">Production Checklist</a></li>                                                                                           
                                                </ul>
                                            </li>
                                            )}
                                            <li>
                                                <a style={{color:'#FFFFFF'}} href="#"><strong>{"Hi, " + loggedInUser['firstname']}</strong></a>                                                
                                                <ul className="dropdown">
                                                    <li><a href="#" onClick={handleLogOut}><strong>Logout</strong></a></li>
                                                    <li><a href="/profileupdate">Manage My Profile</a></li>
                                                    <li><a href="/myabsences">My Absences</a></li>
                                                </ul>
                                            </li>
                                        </>
                                    )}
                                    {!isLoggedIn && (
                                        <>
                                            <li><a style={{color:"#FFFFFF"}} href="/bestpractices"> Best Practices</a></li>
                                            <li><a style={{color:'#FFFFFF'}} href="/contact"><strong>Contact us</strong></a></li>
                                            <li><a style={{color:'#FFFFFF'}} href="/registration"><strong>Login/Register</strong></a></li>
                                        </>
                                            
                                    )}
                        </ul>
                 </div> 
                
            </div>
        </header>
    </div>

    {isMenuOpen && (
        <>
        <style>{`
            #mobile-sidebar-nav, #mobile-sidebar-nav * { box-sizing: border-box; }
            #mobile-sidebar-nav a { color: #003165 !important; text-decoration: none !important; display: block !important; }
            #mobile-sidebar-nav a:hover, #mobile-sidebar-nav a:focus { background-color: #f0f4f8 !important; }
            #mobile-sidebar-nav .mobile-close-btn { color: #ffa800 !important; display: inline !important; }
        `}</style>
        <div id="mobile-sidebar-nav" style={{position: 'fixed', top: 0, left: 0, width: '280px', height: '100vh', overflowY: 'auto', WebkitOverflowScrolling: 'touch', backgroundColor: '#fff', zIndex: 9999, boxShadow: '2px 0 8px rgba(0,0,0,0.3)'}}>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 16px', borderBottom: '2px solid #ffa800', backgroundColor: '#003165'}}>
                <span style={{color: '#fff', fontWeight: 'bold', fontSize: '16px'}}>Menu</span>
                <a href="#" onClick={(e) => { e.preventDefault(); handleMenuToggle(); }} style={{color: '#ffa800', fontSize: '22px', textDecoration: 'none'}}><i className="fa fa-times"></i></a>
            </div>
            <nav style={{padding: '8px 0'}}>
                {loggedInUser && loggedInUser['role.name'] === 'checklist_viewer' ? (
                    <>
                        <a href="/" style={mobileMenuLink}>Home</a>
                        <a href="/events" style={mobileMenuLink}>Upcoming Events</a>
                        <a href="/mediabooking" style={mobileMenuLink}>Book Media Team</a>
                        <div onClick={() => toggleSection('prodday_cv')} style={mobileMenuHeading}>
                            <span>Production Day</span>
                            <i className={openSections['prodday_cv'] ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} style={{fontSize: '12px', color: '#ffa800'}} />
                        </div>
                        {openSections['prodday_cv'] && (
                            <>
                                <a href="/readinesscheck" style={mobileMenuSubLink}>Production Checklist</a>
                                <a href="/productionroom" style={mobileMenuSubLink}>In Production Room</a>
                            </>
                        )}
                        <a href="/bestpractices" style={mobileMenuLink}>Best Practices</a>
                        <a href="/contact" style={mobileMenuLink}>Contact us</a>
                        <div style={{borderTop: '1px solid #e0e0e0', margin: '8px 0'}} />
                        <a href="#" onClick={handleLogOut} style={mobileMenuLink}>Logout</a>
                    </>
                ) : (
                    <>
                        <a href="/" style={mobileMenuLink}>Home</a>
                        <a href="/about" style={mobileMenuLink}>About us</a>

                        {isLoggedIn && (
                            <>
                                <a href="/rota" style={mobileMenuQuickLink}><i className="fa fa-calendar" style={{marginRight: '8px'}} />Rota</a>
                                <a href="/clockin" style={mobileMenuQuickLink}><i className="fa fa-clock-o" style={{marginRight: '8px'}} />Clock In</a>
                                <a href="/requestabsence" style={mobileMenuQuickLink}><i className="fa fa-paper-plane" style={{marginRight: '8px'}} />Request Absence</a>
                                {loggedInUser && loggedInUser['role.name'] !== 'checklist_viewer' && (
                                    <a href="/mevents" style={mobileMenuQuickLink}><i className="fa fa-film" style={{marginRight: '8px'}} />Media Only Events</a>
                                )}
                            </>
                        )}

                        <div onClick={() => toggleSection('events')} style={mobileMenuHeading}>
                            <span><i className="fa fa-star" style={{marginRight: '8px', color: '#ffa800'}} />Events</span>
                            <i className={openSections['events'] ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} style={{fontSize: '12px', color: '#ffa800'}} />
                        </div>
                        {openSections['events'] && (
                            <>
                                <a href="/events" style={mobileMenuSubLink}>Upcoming Events</a>
                                <a href="/mediabooking" style={mobileMenuSubLink}>Book Media Team</a>
                                {isLoggedIn && <a href="/mevents" style={mobileMenuSubLink}>Media Only Events</a>}
                            </>
                        )}

                        {isLoggedIn && (
                            <>
                                <a href="/onboarding" style={mobileMenuLink}>Training</a>

                                <div onClick={() => toggleSection('team')} style={mobileMenuHeading}>
                                    <span><i className="fa fa-users" style={{marginRight: '8px', color: '#ffa800'}} />The Team</span>
                                    <i className={openSections['team'] ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} style={{fontSize: '12px', color: '#ffa800'}} />
                                </div>
                                {openSections['team'] && (
                                    <>
                                        <a href="/teamdistribution" style={mobileMenuSubLink}>Team Distribution</a>
                                        <a href="/absences" style={mobileMenuSubLink}>View Absences</a>
                                        <a href="/birthdays" style={mobileMenuSubLink}>Birthdays</a>
                                        <a href="/improvements" style={mobileMenuSubLink}>Process Improvements</a>
                                        <a href="/contact" style={mobileMenuSubLink}>Contact us</a>
                                        {loggedInUser && loggedInUser['role.name'] === 'admin' && (
                                            <a href="https://docs.google.com/spreadsheets/d/1_25kdmgYRLzpgKmOmW5ZE34Qyuggf7sjLJqDk1pydeQ/edit?usp=sharing" target="_blank" style={mobileMenuSubLink}>Skills Matrix</a>
                                        )}
                                    </>
                                )}
                            </>
                        )}

                        {isLoggedIn && (
                            <>
                                <div onClick={() => toggleSection('prodday')} style={mobileMenuHeading}>
                                    <span><i className="fa fa-video-camera" style={{marginRight: '8px', color: '#ffa800'}} />Production Day</span>
                                    <i className={openSections['prodday'] ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} style={{fontSize: '12px', color: '#ffa800'}} />
                                </div>
                                {openSections['prodday'] && (
                                    <>
                                        <a href="/readinesscheck" style={mobileMenuSubLink}>Production Checklist</a>
                                        <a href="/productionroom" style={mobileMenuSubLink}>In Production Room</a>
                                    </>
                                )}
                            </>
                        )}
                        <a href="/bestpractices" style={mobileMenuLink}>Best Practices</a>
                        <a href="/contact" style={mobileMenuLink}>Contact us</a>

                        {loggedInUser !== null && loggedInUser['role.name'] === 'admin' && (
                            <>
                                <div style={{borderTop: '1px solid #e0e0e0', margin: '8px 0'}} />
                                <div onClick={() => toggleSection('admin')} style={mobileMenuHeading}>
                                    <span><i className="fa fa-cog" style={{marginRight: '8px', color: '#ffa800'}} />Admin Panel</span>
                                    <i className={openSections['admin'] ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} style={{fontSize: '12px', color: '#ffa800'}} />
                                </div>
                                {openSections['admin'] && (
                                    <>
                                        <a href="/manageusers" style={mobileMenuSubLink}>Manage Users</a>
                                        <a href="/manageevents" style={mobileMenuSubLink}>Manage Events</a>
                                        <a href="/managemembersclockin" style={mobileMenuSubLink}>Manage ClockIn</a>
                                        <a href="/manageabsences" style={mobileMenuSubLink}>Manage Absences</a>
                                        <a href="/createrota" style={mobileMenuSubLink}>Create Rota</a>
                                        <a href="/managerota" style={mobileMenuSubLink}>Update Rota</a>
                                        <a href="/managerotaroles" style={mobileMenuSubLink}>Rota Roles</a>
                                        <a href="/manageconfig" style={mobileMenuSubLink}>Team Config</a>
                                        <a href="/broadcastemail" style={mobileMenuSubLink}>Broadcast Email</a>
                                        <a href="/addincident" style={mobileMenuSubLink}>Add Incident</a>
                                        <a href="/viewincident" style={mobileMenuSubLink}>View Incidents</a>
                                        <a href="/manageprodchecklist" style={mobileMenuSubLink}>Production Checklist</a>
                                    </>
                                )}
                            </>
                        )}

                        <div style={{borderTop: '1px solid #e0e0e0', margin: '8px 0'}} />
                        {isLoggedIn ? (
                            <>
                                <div onClick={() => toggleSection('profile')} style={mobileMenuHeading}>
                                    <span><i className="fa fa-user" style={{marginRight: '8px', color: '#ffa800'}} />Hi, {loggedInUser && loggedInUser['firstname']}</span>
                                    <i className={openSections['profile'] ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} style={{fontSize: '12px', color: '#ffa800'}} />
                                </div>
                                {openSections['profile'] && (
                                    <>
                                        <a href="/profileupdate" style={mobileMenuSubLink}>My Profile</a>
                                        <a href="/myabsences" style={mobileMenuSubLink}>My Absences</a>
                                        <a href="#" onClick={handleLogOut} style={mobileMenuSubLink}>Logout</a>
                                    </>
                                )}
                            </>
                        ) : (
                            <a href="/registration" style={mobileMenuLink}>Login / Register</a>
                        )}
                    </>
                )}
            </nav>
        </div>
        <div onClick={handleMenuToggle} style={{position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.4)', zIndex: 9998}} />
        </>
    )}

    </Fragment>
    )
}

const mapStateToProps = (state) => {
    return{
       isLoggedIn: state.authReducer.isLoggedIn,
       loggedInUser: state.authReducer.user
    };
    
};

const mapDispatchToProps = {
    logout
};

export default connect(mapStateToProps, mapDispatchToProps)(Topbar);

